import { Stack, Typography } from '@mui/material';
import { useAppSelector } from '@libs/redux/store';
import SearchResult from '@shared/components/SearchResult';
import MaterialSearchResultItem from '@shared/components/MaterialSearchResultItem';
import GoodsSearchResultItem from '@shared/components/GoodsSearchResultItem';
import { FormattedMessage } from 'react-intl';

const SearchResults = () => {
  const isSearchActive = useAppSelector(state => state.appUi.isSearchActive);
  const searchFilter = useAppSelector(state => state.appUi.searchFilter);
  const searchResults = useAppSelector(state => state.searchResults);
  const materialResults = useAppSelector(
    state => state.materialSearchResults.materialSearchResults,
  );
  const goodsResults = useAppSelector(state => state.materialSearchResults.goodsSearchResults);

  if (!isSearchActive) {
    return null;
  }

  const showClients = searchFilter === 'clients';
  const showGoods = searchFilter === 'goods';
  const hasClients = showClients && searchResults.searchResults.length > 0;
  const hasMaterials = searchFilter === 'material' && materialResults.length > 0;
  const hasGoods = showGoods && goodsResults.length > 0;

  if (!hasClients && !hasMaterials && !hasGoods) {
    return (
      <Stack alignItems="center" marginY={5}>
        <Typography color="secondary.main" fontWeight="bold">
          <FormattedMessage id="searchResult.noData" defaultMessage="Zatím žádné výsledky..." />
        </Typography>
      </Stack>
    );
  }

  return (
    <>
      {showClients &&
        searchResults.searchResults.map(client => (
          <SearchResult
            key={client.id}
            sx={{
              transform: `${!isSearchActive ? 'translateX(-160%)' : 'translateX(0)'}`,
              transition: 'transform 0.5s ease-in-out',
            }}
            clientData={client}
          />
        ))}
      {searchFilter === 'material' &&
        materialResults.map(item => (
          <MaterialSearchResultItem
            key={item.id}
            item={item}
            sx={{
              transform: !isSearchActive ? 'translateX(-160%)' : 'translateX(0)',
              transition: 'transform 0.5s ease-in-out',
            }}
          />
        ))}
      {showGoods &&
        goodsResults.map(item => (
          <GoodsSearchResultItem
            key={item.id}
            item={item}
            sx={{
              transform: !isSearchActive ? 'translateX(-160%)' : 'translateX(0)',
              transition: 'transform 0.5s ease-in-out',
            }}
          />
        ))}
    </>
  );
};

export default SearchResults;
